// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__13BhQ","fileBtn":"File_fileBtn__3RpNr","closeBtn":"File_closeBtn__1JrvR","fileSelected":"File_fileSelected___K9yR","disabled":"File_disabled__1ZDWd"};